import getBasePath from '../../../../common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'divisao');

const divisaoActions = {
  ...genericActions(basePath),
  hierarquia: { method: 'GET', url: `${basePath}/hierarquia` },
  hierarquiaFilha: { method: 'GET', url: `${basePath}/hierarquia-filha` },
  pesquisasrDivisoesSuperiores: { method: 'GET', url: `${basePath}/pai/hierarquia/{idEstruturaUsuario}` },
  listarFiltrado: { method: 'GET', url: `${basePath}?tamanhoPagina={size}&numeroPagina={page}&filtro={filter}` },
  atualizarDivisao: { method: 'PUT', url: `${basePath}/{id}` },
  listarAutocomplete: { method: 'GET', url: `${basePath}?nome={nome}` },
};

export default resource => resource(`${basePath}`, {}, divisaoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/divisao.js